import { render, staticRenderFns } from "./RsaConfigurazionePaiDomiciliareAccessiCategorieModalEditComponent.vue?vue&type=template&id=35187c3b"
import script from "./RsaConfigurazionePaiDomiciliareAccessiCategorieModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazionePaiDomiciliareAccessiCategorieModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports